import React from 'react';
import { connect } from 'react-redux';

import BackgroundImage from '../../BackgroundImage';
import { formatPlayerShots, getThirdPartyRanking, getRatingDetails, setRatingChoice } from '../../../utils';
import { EventTypes } from '../../../utils/events';
import styles from './organizer.scss';
import { ratingTypes } from '../../../utils/constants';
import { getClickAttrs } from '../../Analytics/gtag';
import withAuth from '../../hocs/withAuth';

const OrganizerCard = (props) => {
    const { organizer, user, sendMessage, className, paidHit, coreUI, eventType, providerEmail, 'data-testid': dataTestId } = props;
    const About = () => {
        const {
            description,
            atpOrWtaRank,
            backhand,
            college,
            collegeData,
            collegePosition,
            dominantHand,
            isPro,
            gender,
            thirdPartyRankings,
            coachingExperienceStatus,
            coachingExperienceTypeId,
            playerExperienceStatus,
            playerExperienceTypeId,
        } = organizer;

        const atpWtaRank = getThirdPartyRanking(thirdPartyRankings, gender === 'Female' ? 'WTA' : 'ATP', isPro);
        const playerRating = getRatingDetails(setRatingChoice({ player: organizer, utrType: 'sanctioned' }), user?.isPowered, true);
        const { playerExperienceTypes, coachingExperienceTypes } = coreUI.types;
        const aboutData = [];

        if (description) {
            aboutData.push({
                title: 'Description',
                value: description,
            });
        }

        if (playerRating) {
            aboutData.push({
                title: `${ratingTypes.tennis} Rating`,
                value: playerRating.value,
            });
        }

        if (backhand || dominantHand) {
            aboutData.push({
                title: 'Dominant Hand',
                value: formatPlayerShots(dominantHand, backhand),
            });
        }
        if (college && collegeData) {
            aboutData.push({
                title: 'College',
                value: `${collegeData.displayName} ${collegePosition && `#${collegePosition}`}`,
            });
        }

        if ((isPro || atpOrWtaRank) && atpWtaRank.length > 0) {
            aboutData.push({
                title: `${gender === 'Female' ? 'WTA' : 'ATP'} Rank`,
                value: atpWtaRank,
            });
        }
        if (playerExperienceTypeId && playerExperienceStatus) {
            aboutData.push({
                title: 'Playing Experience',
                value: `${playerExperienceStatus} ${playerExperienceTypes.find(type => type.id === playerExperienceTypeId)?.label}`,
            });
        }
        if (coachingExperienceTypeId && coachingExperienceStatus) {
            aboutData.push({
                title: 'Coaching Experience',
                value: `${coachingExperienceStatus} ${coachingExperienceTypes.find(type => type.id === coachingExperienceTypeId)?.label}`,
            });
        }
        return (
            <div className={`${styles.about}`}>
                {aboutData.map((data, i) => {
                    return (
                        <div
                            className={`${styles.value}`}
                            key={`about-item-${i}`}
                            data-testid={dataTestId && `${dataTestId}.about-item-${i}`}
                        >
                            <span data-testid={dataTestId && `${dataTestId}.about-item-${i}.title`}>{data.title}</span>
                            <span className={`${styles.bold}`} data-testid={dataTestId && `${dataTestId}.about-item-${i}.value`}>
                                {data.value}
                            </span>
                        </div>
                    );
                })}
            </div>
        );
    };

    const isFlexLeagueEvent = eventType?.id === EventTypes.FLEX_LEAGUE;

    return (
        <div className={`organizer-card ${className}`}>
            <div className="d-flex">
                <BackgroundImage
                    baseUrl={'/v1/player/'}
                    defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                    images={organizer.playerProfileImages}
                    imageType={'icon'}
                    parentStylesClass={'avatar flex-shrink-0'}
                />
                <div className={`person-details`}>
                    <div
                        className={`text-medium text-dark ${organizer.playerId ? 'cursor-pointer' : ''}`}
                        onClick={() => {
                            if (organizer.playerId) {
                                window.location.href = `/profiles/${organizer.playerId}`;
                            }
                        }}
                        data-testid={dataTestId && `${dataTestId}.name`}
                    >
                        {organizer.displayName}
                    </div>
                    <div className="text-small text-uppercase" data-testid={dataTestId && `${dataTestId}.role`}>{paidHit ? 'Paid Hitter' : 'Provider'}</div>
                </div>
                {isFlexLeagueEvent
                    ? (
                        <div className={`message`}>
                            {providerEmail && (
                                <div className="col-12 mb16">
                                    <a href={`mailto:${providerEmail}`} data-testid={dataTestId && `${dataTestId}.email-link`}><i className="uts uts-email" /></a>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className={`message`}>
                            {(organizer.memberId && user && user.id && user.id !== organizer.memberId) && (
                                <div
                                    className={`click-area click-area-36`}
                                    onClick={() => sendMessage(organizer)}
                                    data-testid={dataTestId && `${dataTestId}.send-message-btn`}
                                    {...getClickAttrs({
                                        category: 'Send Message',
                                        context: 'Send Message',
                                        location: 'Organizer card',
                                    })}
                                >
                                    <i className={`utr utr-message fs24 text-teal`} />
                                </div>
                            )}
                        </div>
                    )}
            </div>
            {(paidHit && Object.keys(organizer).length > 0) && (
                <div data-testid={dataTestId && `${dataTestId}.about-wrapper`}>
                    <hr className="div" />
                    <About />
                </div>
            )}
        </div>
    );
};

function mapStateToProps({ auth, coreUI }) {
    return { auth, coreUI };
}

OrganizerCard.defaultProps = {
    'data-testid': null,
};

export default withAuth(connect(mapStateToProps)(OrganizerCard));
